import React from 'react';

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";

type ContactActionProps = {
    href: string,
    Icon: React.ReactNode
    type: "email" | "tel"
}

const ContactAction: React.FC<ContactActionProps> = (props) => {

    const { href, Icon, type="email"} = props;

    return (
        <Box display="flex" alignItems="center" sx={{mb:1}}>
            {Icon}
            <Link component="a"
                  href={`${type === "email" ? "mailto:":"tel:"}${href}`}
                  rel="noopener noreferrer"
                  sx={{textDecoration: "none", "&:hover": { color: "primary.light"}}}>{href}</Link>
        </Box>
    );
};

export default ContactAction;